import React from 'react'

import InstitutionEntity from 'utils/__interfaces/Perimeter/InstitutionEntity'
import SearchResultItem from 'utils/__interfaces/Perimeter/SearchResultItem'

function SearchInstitutionAdapter(
  searchResultItems: InstitutionEntity[]
): SearchResultItem[] {
  if (
    searchResultItems?.length === undefined ||
    searchResultItems?.length < 1
  ) {
    return []
  }

  return searchResultItems.map(({ id, name, address, numDebiteur }) => ({
    id,
    line1: <>{name}</>,
    lineNumDebiteur: <>{numDebiteur}</>,
    line2: <>{address}</>,
  }))
}

export default SearchInstitutionAdapter
